import { inviteService } from '@/services/invites.service';

const initialState = () => ({
  invitePreview: null,
  status: {
    error: null,
    pending: true,
    resolved: false,
    rejected: false,
  },
});

const state = initialState();

const actions = {
  validateInvite({ commit }, token) {
    commit('VALIDATE_INVITE');
    return inviteService
      .validateInvite(token)
      .then((response) => {
        commit('SUCCESS', response);
        return response;
      })
      .catch((error) => {
        commit('ERROR', error);
      });
  },
};

const mutations = {
  VALIDATE_INVITE(state) {
    state.status = {
      error: null,
      pending: true,
      resolved: false,
      rejected: false,
    };
  },
  SUCCESS(state, invitePreview) {
    state.status = {
      ...state.status,
      pending: false,
      resolved: true,
    };
    state.invitePreview = invitePreview;
  },
  ERROR(state, error) {
    state.status = {
      ...state.status,
      error: error,
      pending: false,
      rejected: true,
    };
  },
};
const getters = {
  invitePreview: (state) => state.invitePreview,

  // status
  error: (state) => state.status.error,
  pending: (state) => state.status.pending,
  resolved: (state) => state.status.resolved,
  rejected: (state) => state.status.rejected,
};

export const validateInvite = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
